<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import ListView from "./components/ListView.vue"
    import HeaderActions from "./components/HeaderActions.vue"
    import axios from 'axios';

    export default {
        components: { Layout, PageHeader, ListView, HeaderActions },
        props: {
            workflowAssignees: Array,
            workflowTemplates: Array
        },
        data() {
            return {
                title: "Workflow Management",
                items: [
                    {
                        text: "Apps",
                        href: "/",
                    },
                    {
                        text: "Workflow Management",
                        active: true,
                    },
                ],
                workflows: []
            };
        },
        computed: {
            // Example Admin, Enterprise Partner, Tax Company, Tax Payer
            browserTitle() {
                return this.$page.props.auth.user.user_type_text + ' - Workflow Management';
            },
            // Example admin, sb, tc, tp
            userTypeAbbr() {
                return this.$page.props.auth.user.user_type_abbr;
            },
        },
        created() {
            this.fetchingData()
        },
        methods: {
            fetchingData() {
                axios.get(route(this.userTypeAbbr + '-fetching-assigned-workflows'), {
                })
                .then(response => {
                    this.workflows = response.data
                })
            }
        }
    };
    </script>
    
    <template>
        <Layout>
            <Head :title="browserTitle" />
            <PageHeader :title="title" :items="items" />
            <HeaderActions 
                :isShowAssignButton="userTypeAbbr == 'tc' ? true : false"
                :isShowSearch="false"
                :workflowAssignees="workflowAssignees"
                :workflowTemplates="workflowTemplates"
                :renderAssignedWorkflows="fetchingData"
            />
            <div class="d-xl-flex">
                <div class="w-100">
                    <div class="d-md-flex">
                        <div class="w-100">
                            <ListView 
                                :workflows="workflows" 
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </template>
    